import Config from '../Config';

const SaleHelper = {

    getSaleTypeName(saleType) {
        if (!saleType) { return ''; }
        switch (saleType) {
            case 0: return 'tv';
            case 1: return 'app';
            case 2: return 'cellular';
            case 3: return 'internet';
            case 4: return 'triple';
            default: return '';
        }
    },

    getAddonsFlowTypeName(flowType) {
        switch (flowType) {
            case null:
            case 0: return 'service';
            case 1: return 'mesh';
            case 2: return 'internetSpeed';
            default: return '';
        }
    },

};

export default SaleHelper;